$(function () {
  $(window).on("load", function () {
    var s = $(".main_slide").slick({
      dots: true,
      slidesToShow: 1,
      arrows: !1,
      autoplay: !0,
      fade: !0,
//      speed: 2e3,
      autoplaySpeed: 4e3,
      pauseOnFocus: !1,
      pauseOnHover: !1
    })
    .on({
      beforeChange: function (l, t, a, o) {
        $(".slick-slide", this).eq(a).addClass("preve-slide"), $(".slick-slide", this).eq(o).addClass("slide-animation")
      },
      afterChange: function () {
        $(".preve-slide", this).removeClass("preve-slide\u3000slide-animation")
      }
    });
    s.find(".slick-slide").eq(0).addClass("slide-animation");
  }),
  $(window).on("scroll", function () {
    $(".anime").each(function () {
      var s = $(this).offset().top,
        i = $(window).scrollTop(),
        e = $(window).height();
      i > s - e + e / 3 && $(this).addClass("anime_start")
    }), $(".lifestyle_article-ttl").each(function () {
      var s = $(this).offset().top,
        i = $(window).scrollTop(),
        e = $(window).height();
      i > s - e + e / 3 && $(this).addClass("move_start")
    })
  });
  
  
  $(".item_area").mCustomScrollbar({
//    axis:"x",
    horizontalScroll: true,
    autoDraggerLength: true,
//    autoDraggerLength: false,
    advanced:{
      updateOnContentResize: true
    }
  });
  
  var box = $('.img_box .img.anime .images'),
      speed = 700;  

  box.each(function(){
    $(this).append('<div class="background"></div>')
    var bk = $(this).find('.background'),
    image = $(this).find('img');
    var counter = 0;

    image.css('opacity','0');
    bk.css('width','0%');

    $(this).closest('.img').on('cssClassAdd', function(){
      if(counter == 0){
        if($(this).is(".anime_start") == true){
          if($(this).hasClass('left')){
            bk.delay(200).animate({'width':'100%'},speed,function(){
              image.css('opacity','1');
              bk.css({'right':'0' , 'left':'auto'});
              bk.animate({'width':'0%'},speed);
            });
          }
          if($(this).hasClass('right')){
            bk.delay(200).animate({'width':'100%'},speed,function(){
              image.css('opacity','1');
              bk.css({'left':'0' , 'right':'auto'});
              bk.animate({'width':'0%'},speed);
            });
          }
        }
        counter = 1;
      }
      
    });
  });
  
});

  
  
// addClass時にイベントを起こす
(function(){
  
  var originalAddClassMethod = jQuery.fn.addClass;
  
  jQuery.fn.addClass = function(){
    
    var result = originalAddClassMethod.apply(this, arguments);
    
    jQuery(this).trigger('cssClassAdd');
    
    return result;
  }
})();